import { Box, Typography } from '@mui/material';
import SearchOffIcon from '@mui/icons-material/SearchOff';

/**
 * TableNodata component
 * 
 * Displays a message when there is no data to display in a table.
 * 
 * @param {string} message - The main message to display. Defaults to "No Data Found!".
 * @param {string} description - A secondary message to display. Defaults to "Currently, there is no data available.".
 * 
 * @returns {JSX.Element} The TableNodata component.
 */
export const TableNodata = ({ message = "No Data Found!", description = "Currently, there is no data available." }) => {

    return (
        <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 2, py: 4 }}>
            <SearchOffIcon sx={{ fontSize: 60, color: "#cbd5e1" }} />
            <Box sx={{ textAlign: "center" }}>
                <Typography sx={{ fontSize: "16px", fontWeight: 700, color: "#1e293b" }}>{message}</Typography>
                <Typography sx={{ fontSize: "13px", color: "#64748b", mt: 0.5 }}>{description}</Typography>
            </Box>
        </Box>
    );
};